import gql from "graphql-tag";

/** Guest-safe Q&A — no user display names (blocked for unauthenticated GraphQL). */
export default gql`
  query getPublicCommentsByListingIdGuest($listingId: Int!) {
    allPublicComments(
      condition: { listingId: $listingId, deletedAt: null }
      orderBy: CREATED_AT_ASC
    ) {
      nodes {
        id
        listingId
        userId
        parentCommentId
        content
        createdAt
        updatedAt
        userByUserId {
          id
          profilePictureUrl
        }
      }
    }
  }
`;
